import React from 'react';
import PropTypes from 'prop-types';
import { SortableElement } from 'react-sortable-hoc';
import cx from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IngredientPpiSection from './IngredientPpiSection';
import IngredientQuantity from '../../../common/IngredientQuantity';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles(theme => ({
  ingredientRoot: {
    backgroundColor: theme.palette.grey[50],
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
    transition: 'border 300ms ease-out'
  },
  ingredientCompleted: {
    borderLeft: `3px solid ${theme.palette.success.main}`
  },
  ingredientIncomplete: {
    borderLeft: `3px solid ${theme.palette.error.main}`
  },
  ingredientName: {
    fontWeight: 500
  },
  truncate: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
}));
const formatFormulaCode = formulaCode => {
  return `${formulaCode.substring(0, 3)} ${formulaCode.substring(
    3,
    7
  )} ${formulaCode.substring(7, formulaCode.length)}`;
};

const IngredientCard = ({
  ingredientName,
  isExcluded,
  itemCode,
  quantity,
  quantityUom,
  owningOrganization,
  selectedPpiDataId,
  completed = false,
  onChangeSelectedPpi,
  legacyFormulaCode,
  globalIngredientId
}) => {
  const classes = useStyles();
  const rootClasses = cx(
    classes.ingredientRoot,
    { [classes.ingredientCompleted]: completed },
    { [classes.ingredientIncomplete]: !completed }
  );
  return (
    <div className={rootClasses}>
      <Grid container spacing={0} style={{ position: 'relative' }}>
        <Grid item md={6} sm={12}>
          <Typography
            variant="body1"
            className={cx(classes.ingredientName, classes.truncate)}
            noWrap
          >
            {ingredientName}
          </Typography>
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          <Typography variant="body1">{`${formatFormulaCode(itemCode)}(${
            legacyFormulaCode ? formatFormulaCode(legacyFormulaCode) : '-'
          })`}</Typography>
        </Grid>
        <Grid item md={2} sm={3} xs={12}>
          <Typography variant="body1">
            <IngredientQuantity quantity={quantity} uom={quantityUom} />
          </Typography>
        </Grid>
        {/* <Grid item md={1} sm={3} xs={12}>
          <Typography variant="body1">{owningOrganization}</Typography>
        </Grid> */}
        <Grid item xs={12} style={{ position: 'relative' }}>
          <IngredientPpiSection
            ingredientOwningOrganization={owningOrganization}
            onChangeSelectedPpi={onChangeSelectedPpi}
            selectedPpiDataId={selectedPpiDataId}
            itemCode={itemCode}
            isExcluded={isExcluded}
            globalIngredientId={globalIngredientId}
            legacyFormulaCode={legacyFormulaCode}
          />
        </Grid>
        <Tooltip title="Drag ingredient to change order">
          <DragIndicatorIcon
            style={{
              color: 'rgba(0, 0, 0, 0.54)',
              position: 'absolute',
              top: '50%',
              marginLeft: '98%',
              // marginRight: '8px',
              cursor: 'grab'
            }}
          />
        </Tooltip>
      </Grid>
    </div>
  );
};

IngredientCard.propTypes = {
  completed: PropTypes.bool,
  ingredientName: PropTypes.string.isRequired,
  itemCode: PropTypes.string.isRequired,
  globalIngredientId: PropTypes.string.isRequired,
  onChangeSelectedPpi: PropTypes.func.isRequired,
  owningOrganization: PropTypes.string,
  quantity: PropTypes.number,
  quantityUom: PropTypes.string,
  selectedPpiDataId: PropTypes.string,
  legacyFormulaCode: PropTypes.string
};

export default SortableElement(IngredientCard);
